import React from 'react'

interface IProps extends React.PropsWithChildren {}

export const MainContent = ({ children }: IProps) =>
  <article id="main-content">
    <div className="common-clipBackground--in"><div id="main-content--clipBackground1" /></div>
    <div className="common-clipBackground--in"><div id="main-content--clipBackground2" /></div>
    <div className="common-clipBackground--in"><div id="main-content--clipBackground3" /></div>
    <div className="common-clipBackground--in"><div id="main-content--clipBackground4" /></div>
    <div className="common-clipBackground--in"><div id="main-content--clipBackground5" /></div>
    <div className="common-clipBackground--in"><div id="main-content--clipBackground6" /></div>
    <div className="common-clipBackground--in"><div id="main-content--clipBackground7" /></div>
    <div className="common-clipBackground--in"><div id="main-content--clipBackground8" /></div>
    <div className="common-clipBackground--in"><div id="main-content--clipBackground9" /></div>
    <div className="common-clipBackground--in"><div id="main-content--clipBackground10" /></div>
    <div className="common-clipBackground--in"><div id="main-content--clipBackground11" /></div>
    <div className="common-clipBackground--in"><div id="main-content--clipBackground12" /></div>
    <div className="common-clipBackground--in"><div id="main-content--clipBackground13" /></div>
    <div className="common-clipBackground--in"><div id="main-content--clipBackground14" /></div>
    {children}
  </article>